import { createRoute } from "@/assets/data/produce/classify";
import store from "@/store";
import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countInventory();
};

const productList = [
    createRoute("prod", "all", "全部产品", "prod-goods-all"),
    createRoute("prod", "device", "农业设备", "prod-goods-category"),
    createRoute("prod", "oem", "OEM产品", "prod-goods-category"),
    createRoute("prod", "project", "工程配套", "prod-goods-category"),
    createRoute("prod", "service", "平台服务", "prod-goods-service"),
    createRoute("prod", "detection", "检测服务", "prod-goods-detection"),
    createRoute("prod", "fertilizer", "农资耗材", "prod-goods-fertilizer"),
    createRoute("prod", "seedling", "果树苗木", "prod-goods-fruit"),
    createRoute("prod", "fruit", "水果鲜花", "prod-goods-fruit"),
    createRoute("prod", "extend", "其它产品", "prod-goods-extend"),
    createRoute("prod", "part", "BOOM库", "prod-goods-part", "manage_external_inventory"),
    createRoute("prod", "maintenance", "售后维保", "prod-goods-maintenance"),
];

export default [
    {
        path: "/prod",
        name: "prod__root__",
        redirect: {
            name: "prod-index",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "prod",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "prod-index",
                component: () => import("@/views/prod/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/prod/mall",
        name: "prod-mall",
        meta: {
            title: "产品管理",
            icon: "prod-inventory",
            parent: "prod",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        // redirect: "/prod/mall/device",
        children: [
            ...productList,
            {
                path: "good/:id(\\d+)?",
                name: "prod-mall-goods-form",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_form.vue"),
                meta: {
                    title: "产品编辑",
                    affix: false,
                },
            },
            {
                path: "good_detail/:id(\\d+)?",
                name: "prod-mall-goods-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_detail.vue"),
                meta: {
                    title: "产品详情",
                    affix: false,
                },
            },
            {
                path: "category",
                name: "prod-mall-category",
                component: () => import("@/views/fms/mall/goods_category.vue"),
                meta: {
                    title: "类型配置",
                    icon: "all-setting",
                    affix: false,
                    permission: "manage_product",
                },
            },
        ],
    },
    {
        path: "/prod/produce",
        name: "prod-produce",
        meta: {
            title: "生产管理",
            icon: "mkt-after-sales-workflows",
            parent: "prod",
            permission: "manage_product_make",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/prod/produce/task",
        children: [
            {
                path: "task",
                name: "prod-produce-task",
                component: () => import("@/views/fms/produce/task/index.vue"),
                meta: {
                    title: "生产任务",
                    icon: "mkt-acceptance",
                    affix: false,
                },
            },
            {
                path: "task-log-template",
                name: "prod-produce-task-log-template",
                component: () => import("@/views/fms/produce/task_log_template/index.vue"),
                meta: {
                    title: "流程模版",
                    icon: "mkt-template",
                    affix: false,
                },
            },
            {
                path: "task-edit/:id(\\d+)?",
                name: "prod-produce-task-edit",
                component: () => import("@/views/fms/produce/task/form.vue"),
                meta: {
                    title: "编辑生产任务",
                    activeMenu: "/prod/produce/task",
                },
                hidden: true,
            },
            {
                path: "task-detail/:id(\\d+)",
                name: "prod-produce-task-detail",
                component: () => import("@/views/fms/produce/task/detail.vue"),
                meta: {
                    title: "生产任务详情",
                    activeMenu: "/prod/produce/task",
                },
                hidden: true,
            },

            {
                path: "plan",
                name: "prod-produce-plan",
                component: () => import("@/views/fms/produce/plan/index.vue"),
                meta: {
                    title: "生产规划",
                    icon: "prod-produce-plan",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/prod/inventory",
        name: "prod-inventory",
        meta: {
            title: "库存管理",
            icon: "prod-inventory",
            parent: "prod",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/prod/inventory/goods",
        children: [
            {
                path: "pending-orders",
                name: "prod-inventory-pending-orders",
                component: () => import("@/views/fms/mall/pending_order.vue"),
                meta: {
                    title: "待发订单",
                    icon: "mkt-acceptance",
                    affix: false,
                    permission: "manage_inventory",
                },
            },
            {
                path: "pending-orders/detail/:id(\\d+)?",
                name: "prod-inventory-pending-orders-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/prod/inventory/pending-orders",
                    permission: "manage_inventory",
                },
            },
            {
                path: "inv-adjust",
                name: "prod-produce-inv-adjust",
                component: () => import("@/views/fms/produce/inv_adjust/index.vue"),
                meta: {
                    title: "库存申请",
                    icon: "prod-inv-adjust",
                    affix: false,
                },
            },
            {
                path: "inv-adjust-oem",
                name: "prod-produce-inv-adjust-oem",
                component: () => import("@/views/fms/produce/oem_inv_adjust/index.vue"),
                meta: {
                    title: "OEM申请",
                    icon: "prod-inv-adjust",
                    affix: false,
                },
            },
            {
                path: "device",
                name: "prod-inventory-device",
                component: () => import("@/views/fms/device"),
                meta: {
                    title: "设备入库",
                    icon: "prod-inventory-device",
                    affix: false,
                    permission: "manage_inventory",
                },
            },
            {
                path: "goods",
                name: "prod-produce-inventory",
                component: () => import("@/views/fms/produce/inventory/index.vue"),
                meta: {
                    title: "库存管理",
                    icon: "prod-produce-inventory",
                    affix: false,
                    permission: "manage_inventory",
                },
            },
            {
                path: "inventory_detail/:id(\\d+)?",
                name: "prod-mall-inventory-detail",
                hidden: true,
                component: () => import("@/views/fms/produce/inventory/detail.vue"),
                meta: {
                    title: "库存详情",
                    affix: false,
                    activeMenu: "/prod/produce/inventory",
                },
            },
            {
                path: "stock-record",
                name: "prod-mall-stock-record",
                component: () => import("@/views/fms/mall/stock_record.vue"),
                meta: {
                    title: "流转记录",
                    icon: "prod-stock-record",
                    affix: false,
                    permission: "manage_inventory",
                },
            },
            {
                path: "stat",
                name: "prod-produce-stat",
                component: () => import("@/views/fms/produce/stat/index.vue"),
                meta: {
                    title: "统计分析",
                    icon: "all-stat",
                    affix: false,
                    permission: "manage_inventory",
                },
            },
        ],
    },
    {
        path: "/prod/logistics",
        name: "prod-logistics",
        meta: {
            title: "物流管理",
            icon: "prod-logistics",
            parent: "prod",
            affix: false,
            permission: "manage_inventory",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/prod/logistics/package",
        children: [
            {
                path: "package",
                name: "prod-logistics-package",
                component: () => import("@/views/prod/package_hall.vue"),
                meta: {
                    title: "包裹中心",
                    icon: "prod-package",
                    affix: false,
                },
            },
            {
                path: "package/detail/:id(\\d+)?",
                name: "prod-inventory-pending-mall-orders-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/prod/logistics/package",
                    permission: "manage_inventory",
                },
            },
            {
                path: "package/detail/:id(\\d+)?",
                name: "prod-inventory-pending-sign-orders-detail",
                hidden: true,
                component: () => import("@/views/fms/order/components/sign-detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/prod/logistics/package",
                    permission: "manage_inventory",
                },
            },
        ],
    },
    {
        path: "/prod/purchase",
        name: "prod-purchase",
        meta: {
            title: "采购管理",
            icon: "prod-purchase",
            parent: "prod",
            affix: false,
            permission: "manage_order_purchase",
        },
        beforeEnter: async (to, from, next) => {
            store.dispatch("goods/loadCategories");
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/prod/purchase/order",
        children: [
            {
                path: "order",
                name: "prod-purchase-order",
                component: () => import("@/views/pus/order.vue"),
                meta: {
                    title: "采购订单",
                    icon: "prod-purchase-order",
                    affix: false,
                },
            },
            {
                path: "order/:id",
                name: "prod-purchase-order-detail",
                hidden: true,
                component: () => import("@/views/pus/order_detail.vue"),
                meta: {
                    title: "订单详情",
                    affix: false,
                    activeMenu: "/prod/purchase/order",
                },
            },
            {
                path: "order/edit/:id(\\d+)?",
                name: "prod-purchase-order-edit",
                hidden: true,
                component: () => import("@/views/pus/order_edit.vue"),
                meta: {
                    title: "订单编辑",
                    affix: false,
                    activeMenu: "/prod/purchase/order",
                },
            },
            {
                path: "supplier",
                name: "prod-purchase-supplier",
                component: () => import("@/views/pus/supplier.vue"),
                meta: {
                    title: "供应商管理",
                    icon: "prod-purchase-supplier",
                    affix: false,
                },
            },
            {
                path: "supplier/detail/:id(\\d+)?",
                name: "prod-purchase-supplier-detail",
                hidden: true,
                component: () => import("@/views/pus/supplier_detail.vue"),
                meta: {
                    title: "供应商详情",
                    affix: false,
                    activeMenu: "/prod/purchase/supplier",
                },
            },
        ],
    },
];
